import './ContextMenu.css';

type DropdownMenuProps = {
  show: boolean;
  values: DropdownValue[];
};

type DropdownValue = {
  label?: string;
  icon: React.ReactElement;
  onClick: () => void;
  isActive?: boolean;
};

export const DropdownMenu = ({ show, values }: DropdownMenuProps) => {
  if (show) {
    return (
      <ul className="menu menu-list dropdown-menu-open">
        {values.map(({ label, icon, onClick, isActive }, index) => (
          <li
            key={index}
            className={`menu_item ${isActive ? 'active' : ''}`}
            onClick={onClick}
          >
            {icon}
            {label}
          </li>
        ))}
      </ul>
    );
  }
  return null;
};

export const DropdownGrid = ({ show, values }: DropdownMenuProps) => {
  if (show) {
    return (
      <ul className="menu menu-grid dropdown-menu-open">
        {values.map(({ icon, onClick, isActive }, index) => (
          <li
            key={index}
            className={`menu_item ${isActive ? 'active' : ''}`}
            onClick={onClick}
          >
            {icon}
          </li>
        ))}
      </ul>
    );
  }
  return null;
};
